import TopTabs from './TopTabs';

export default TopTabs;
